export default "__VITE_ASSET__DbiLbEWH__"